import React from "react";
import "../styles/pages/privacypolicy.css";
import SubHome from "../components/SubHome";

const Security = () => {
  return (
    <>
      <SubHome mainHeading="seguridad" listItem="seguridad" />
      <div className="privacy-policy-container">
        <div
          className="heading-content-section"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2 className="main-heading">seguridad</h2>
          <div
            className="heading-border"
            style={{ marginBottom: "40px" }}
          ></div>
        </div>

        <p>
        En Cheffy, tu seguridad es nuestra máxima prioridad. Nos aseguramos de que todos los pagos se procesen a través de una plataforma segura y encriptada, para que puedas confiar en que tu información financiera está protegida en cada paso.
        </p>

        <p>
        Para nuestros Cookers, los pagos de los Eaters van directamente y de forma segura a tu cuenta bancaria vinculada, sin intermediarios ni periodos de espera. Esto garantiza que cada vez que cocines, recibirás tus ganancias de manera rápida y segura, depositadas directamente en tu cuenta.
        </p>
        <p>
        Con Cheffy, puedes concentrarte en crear comidas increíbles mientras nosotros nos encargamos de la seguridad en cada transacción.
        </p>
      </div>
    </>
  );
};

export default Security;
